/**
 * Every design binding ending in `Fa` means Persian-digit formatted. A raw Latin
 * number must never reach a Persian label — codes and serials are the opposite case
 * and stay Latin inside dir="ltr" islands.
 */

const PERSIAN_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] as const

/** Converts every ASCII digit in a string, leaving other characters untouched. */
export function toFaDigits(value: string): string {
  return value.replace(/[0-9]/g, (d) => PERSIAN_DIGITS[Number(d)])
}

export function faNumber(value: number): string {
  return toFaDigits(String(value))
}

/** «۲۷ از ۴۰» — the capacity label on the pallet screen. */
export function faFraction(current: number, max: number): string {
  return `${faNumber(current)} از ${faNumber(max)}`
}

/**
 * «۳۸ / ۴۰» — the recent-pallet list's own form. The artboard uses the spaced slash here
 * and the «از» wording on the capacity bar; they are not interchangeable.
 */
export function faRatio(current: number, max: number): string {
  return `${faNumber(current)} / ${faNumber(max)}`
}

/** Parses a keypad entry that may contain Persian digits back into Latin. */
export function fromFaDigits(value: string): string {
  return value.replace(/[۰-۹]/g, (d) => String(PERSIAN_DIGITS.indexOf(d as (typeof PERSIAN_DIGITS)[number])))
}
